export default __webpack_public_path__ + "static/media/offer-icon-banner.146174eb.svg";